/**
 * "Sizes" — Widget section (ADR-0074).
 * Reconciled from apps/widget `chat-size/size.ts` (ADR-0041's five sizes).
 *
 * The page documented a second axis — the `normal` / `split` layout mode — until
 * ADR-0571 removed the split view and the mode with it. The SLUG is deliberately
 * unchanged (`widget/surfaces`): an existing link to this page must keep
 * resolving, and "surfaces" still describes what it documents.
 */
import type { DocPageContent } from '../types';

export const WIDGET_SURFACES_PAGE: DocPageContent = {
  slug: 'widget/surfaces',
  titleKey: 'docs.widget.surfaces.title',
  descriptionKey: 'docs.widget.surfaces.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.widget.surfaces.lead' },

    { kind: 'heading', level: 2, id: 'sizes', textKey: 'docs.widget.surfaces.sizes.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.widget.surfaces.size.small',
        'docs.widget.surfaces.size.medium',
        'docs.widget.surfaces.size.large',
        'docs.widget.surfaces.size.fullscreen',
        'docs.widget.surfaces.size.embedded',
      ],
    },

    { kind: 'heading', level: 2, id: 'choose', textKey: 'docs.widget.surfaces.choose.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.surfaces.choose.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.widget.surfaces.next.chat.title',
          textKey: 'docs.widget.surfaces.next.chat.text',
          to: { docSlug: 'widget/chat' },
        },
        {
          titleKey: 'docs.widget.surfaces.next.theming.title',
          textKey: 'docs.widget.surfaces.next.theming.text',
          to: { docSlug: 'widget/theming' },
        },
      ],
    },
  ],
};
